export const MENSAJE = {
    ERROR: 'Se ha presentado un error, por favor envianos un reporte detallado de la operación que estabas tratando de ejecutar',
  };